<template>
    <div id="login">
        <div class="bg-box">
            <div class="bg-left">
                <img src="../assets/images/novel_illu.png" alt="">
            </div>
            <div class="login-box">
                <div class="title-box">
                    <h5>{{$t('_web_title')}}</h5>
                </div>
                <div class="login-box-input">
                    <el-divider>验证码快速登录</el-divider>
                    <el-form>
                        <el-form-item>
                            <el-input style="width: 75%;display: inline-block" :placeholder="(getsmstype()=='sms')?$t('login.phone'):$t('login.email')"  v-model="from.phone"  clearable prefix-icon="el-icon-message"
                                      class="login-input" ></el-input>
                            <el-button type="primary" @click="sendCode" style="width: 20%;display: inline-block;margin-left: 10px"  :disabled="!from.sendcodeDisable">{{sendDesc}}</el-button>
                        </el-form-item>
                        <el-form-item >
                            <el-input :placeholder="$t('login.vcode')" v-model="from.code"   clearable clearable prefix-icon="el-icon-circle-check"
                                      class="login-input" ></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="login-button" :class="from.loginModule==2?['m0']:''">
                        <el-button type="primary" @click="login()" style="width: 100%">{{$t('_login')}}</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  import config from "../config";
  import util from "../utils/util";
  export default {
    name: "login",
    metaInfo() {
      return {
         title:this.$i18n.t('_web_title'), // set a title
      }
    },
    data() {
      return {
        username: '',
        password: '',
          title: this.$i18n.t('_web_title'), // set a title
         from:{
             phone:'',
             code:'',
           sendcodeTime:0,
           sendcodeDisable:true,
         }
      }
    },
    created() {
      sessionStorage.clear();
      this.getvCode();
    },
      computed:{
            sendDesc(){
              if(this.from.sendcodeDisable) return this.$i18n.t('login.send') ;
              return this.from.sendcodeTime+'';
            },

      },
    methods: {
      ...util,
        getvCode() {
            this.$axios.get("admin/create_captcha", '').then((res) => {
                this.from.identifyCode = res.data.captcha;
                this.from.key = res.data.key;
            });
        },
        agreementurl(){
          return config.server_url+'illustration/view?mark=agreement';
        },
        sendCode(){
            if(!this.from.phone){
                this.$message.error(this.$i18n.t((this.getsmstype()=='sms')?'login.nophone':'login.noemail'));
                return ;
            }

            this.from.sendcodeDisable=false;
            this.from.sendcodeTime=60;
           const interval =  setInterval(()=>{
                this.from.sendcodeTime --;
                if(this.from.sendcodeTime<0){
                    this.from.sendcodeDisable=true;
                    clearInterval(interval);
                }
            },1000);
            this.$axios.post('api/common/sms_send',{type:'quick_login',mobile:this.from.phone}).then((res) => {
                console.log(res.data);
            });
        },
      login() {
           if(this.paramsCheck()){
               let data = {phone: this.from.phone, code:this.from.code,source:'author'};
               this.$ajax({
                   method: 'post',
                   url: 'api/quick_login',
                   data: data,
               }).then((res) => {
                   this.toLogin(res);
               }).catch((err) => {
                   this.$message.error(err.message);
               });
           }
      },
        toLogin(res){
            sessionStorage.setItem("token", res.data.access_token);
            this.$router.push({
                path: '/home'
            })
        },
        paramsCheck(){
          if(!this.from.phone){
            this.$message.error(this.$i18n.t((this.getsmstype()=='sms')?'login.nophone':'login.noemail'));
            return false;
          }
          if(!this.from.code){
            this.$message.error(this.$i18n.t('login.nocode'));
            return false;
          }
            return true
        }
    }
  }
</script>

<style scoped lang="less">
    .m0{
        margin: 0;
    }
    .flex{
           display:flex;
           align-items:center;
    }

    .get-code {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .identifyCode {
        width: 100px;
        height: 40px;
        margin-left: 10px;
        border-radius: 6px;
    }
    @media screen and (max-width: 750px) {
        #login {
            width: 100%;
            height: 100%;
            /*background: url("../assets/images/bg.jpg") no-repeat;*/
            .get-code {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .identifyCode {
                width: 100px;
                height: 40px;
                margin-left: 10px;
                border-radius: 6px;
            }
            .bg-box {
                width: 100%;
                height: 640px;
                background: white;
                display: flex;
                position: fixed;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
            .m0{
                margin: 0;
            }
            .bg-left {
                display: none;

                img {
                    width: 589px;
                    height: 484px;
                }
            }


            .login-box {
                width: 400px;
                height: 400px;
                background: rgba(255, 255, 255, 0.7);
                border-radius: 8px;
                padding: 10px 30px 10px 30px;
                box-sizing: border-box;
            }


            .login-box {
                .title-box {
                    padding-top: 80px;
                    padding-bottom: 50px;
                }

                .title-box h5 {
                    text-align: center;
                    font-size: 24px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: rgba(10, 28, 51, 1);
                }

                .login-input {
                    width: 300px;
                    box-sizing: border-box;
                }

                .login-box-input {
                    margin: 0 auto;
                    width: 300px;
                }
            }


            .login-button {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .get-code {
                display: flex;
            }

            .identifyCode {
                width: 100px;
                height: 40px;
                margin-left: 10px;
                border-radius: 6px;
            }

            .input-box {
                position: relative;
                margin-bottom: 36px;

                .input-icon {
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 13px;
                    height: 15px;
                }
            }

        }
    }

    @media screen and (min-width: 750px) {
        #login {
            width: 100%;
            height: 100%;
            background: url("../assets/images/bg.jpg") no-repeat;

            .bg-box {
                width: 1200px;
                height: 640px;
                background: white;
                display: flex;
                position: fixed;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }

            .bg-left {
                width: 700px;
                height: 640px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .bg-left {
                img {
                    width: 589px;
                    height: 484px;
                }
            }

            .login-box {
                width: 400px;
                height: 400px;
                background: rgba(255, 255, 255, 0.7);
                border-radius: 8px;
                padding: 10px 30px 10px 30px;
                box-sizing: border-box;
            }

            .login-box {
                .title-box {
                    padding-top: 80px;
                    padding-bottom: 50px;
                }

                .title-box h5 {
                    text-align: center;
                    font-size: 36px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: rgba(10, 28, 51, 1);
                }

                .login-input {
                    width: 300px;
                    box-sizing: border-box;
                }

                .login-box-input {
                    margin: 0 auto;
                    width: 300px;
                }
            }


            .login-button {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .get-code {
                display: flex;
            }

            .identifyCode {
                width: 100px;
                height: 40px;
                margin-left: 10px;
                border-radius: 6px;
            }

            .input-box {
                position: relative;
                margin-bottom: 36px;

                .input-icon {
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }

        }
    }
</style>